import store from "../store";

// QuoteDocumentFeatures column limits, see docs/quote-document-features.md
export const DOCUMENT_FEATURE_GROUP_NAME_MAX_LENGTH = 256;
export const DOCUMENT_FEATURE_DISPLAY_NAME_MAX_LENGTH = 512;

/**
 * the server fails the whole save on a too long value instead of truncating it, so we cut it here
 * @param value {any}
 * @param maxLength {number}
 * @returns {string}
 */
const getNormalizedFeatureValue = (value, maxLength) => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim().substring(0, maxLength);
};

/**
 * returns a document feature object, null when it is empty (the server skips such entries anyway)
 * @param groupName {any}
 * @param displayName {any}
 * @returns {{groupName: string, displayName: string}|null}
 */
const getQuoteDocumentFeature = (groupName, displayName) => {
  const feature = {
    groupName: getNormalizedFeatureValue(groupName, DOCUMENT_FEATURE_GROUP_NAME_MAX_LENGTH),
    displayName: getNormalizedFeatureValue(displayName, DOCUMENT_FEATURE_DISPLAY_NAME_MAX_LENGTH),
  };
  if (!feature.groupName && !feature.displayName) {
    return null;
  }
  return feature;
};

/**
 * returns the document features of the given db features, de-duplicated and sorted,
 * as the server doesn't guarantee the order
 * @param dbFeatures {array} the db features the document should carry
 * @returns {[{groupName: string, displayName: string}]}
 */
export const getDocumentFeatures = (dbFeatures) => {
  const usedFeatureKeys = {};
  return dbFeatures
    .filter(dbFeature => !!dbFeature)
    .map(dbFeature => getQuoteDocumentFeature(dbFeature.groupName, dbFeature.displayName))
    .filter(feature => {
      if (!feature) {
        return false;
      }
      const featureKey = feature.groupName + "|" + feature.displayName;
      if (usedFeatureKeys[featureKey]) {
        return false;
      }
      usedFeatureKeys[featureKey] = true;
      return true;
    })
    .sort((a, b) => a.groupName.localeCompare(b.groupName) || a.displayName.localeCompare(b.displayName));
};

/**
 * returns the selected features of the quote, to be saved with every quote document
 * @param cartItemsToUse {array} cart items to use instead of the ones in the store
 * @returns {[{groupName: string, displayName: string}]}
 */
export const getQuoteDocumentFeatures = (cartItemsToUse = null) => {
  const cartItems = cartItemsToUse || store.getState().cartState.cartItems;
  return getDocumentFeatures(cartItems
    .filter(cartItem => cartItem && cartItem.cartFeature && cartItem.cartFeature.dbFeature && !cartItem.isRemoved)
    .map(cartItem => cartItem.cartFeature.dbFeature));
};
